import { doDeleteRequest, doGetRequest, doPostRequest, doPutRequest } from "./mainAPI";
import { CENTER, RESIDENT } from "../constants/mainAPI";
import { ResidentShortData, ResidentsSuccessResponse, ResidentSuccessResponse } from "../types/api/resident";
import { ErrorResponseType } from "../types/api/main";
import { toFormData } from "../utils/toFormData";

export const getResidents = (
    centerId: string | undefined,
    callback?: (resp: ResidentsSuccessResponse) => any,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
    searchParams?: Record<string, any>,
) => {
    return doGetRequest(`${CENTER}/${centerId || 0}/${RESIDENT}`, true, searchParams, callback, errorCallback);
};

export const getResident = (
    centerId: string | undefined,
    residentId: number | undefined,
    callback?: (resp: ResidentSuccessResponse) => void,
    errorCallback?: (resp: any) => void,
) => {
    return doGetRequest(`${CENTER}/${centerId || 0}/${RESIDENT}/${residentId}`, true, {}, callback, errorCallback);
};

export const createNewResident = (
    centerId: string | undefined,
    data: ResidentShortData,
    callback?: (resp: any) => void,
    errorCallback?: (resp: any) => void,
) => {
    const formData = toFormData(data);

    return doPostRequest(`${CENTER}/${centerId || 0}/${RESIDENT}`, true, formData, {}, callback, errorCallback);
};

export const editResident = (
    centerId: string | undefined,
    residentId: number | undefined,
    data: ResidentShortData,
    callback?: (resp: any) => void,
    errorCallback?: (resp: any) => void,
) => {
    const formData = toFormData(data);

    return doPutRequest(
        `${CENTER}/${centerId || 0}/${RESIDENT}/${residentId}`,
        true,
        formData,
        {},
        callback,
        errorCallback,
    );
};

export const deleteResident = (
    centerId: string | undefined,
    residentId: number | undefined,
    callback?: (resp: any) => void,
    errorCallback?: (resp: any) => void,
) => {
    return doDeleteRequest(`${CENTER}/${centerId || 0}/${RESIDENT}/${residentId}`, true, {}, callback, errorCallback);
};
